import { render, staticRenderFns } from "./AMForgotUsrnmComponent.vue?vue&type=template&id=94ac91c0&scoped=true"
import script from "./AMForgotUsrnmComponent.vue?vue&type=script&lang=js"
export * from "./AMForgotUsrnmComponent.vue?vue&type=script&lang=js"
import style0 from "./AMForgotUsrnmComponent.vue?vue&type=style&index=0&id=94ac91c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac91c0",
  null
  
)

export default component.exports